<h1
  mat-dialog-title
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
  style="text-align: center; color: blue"
>
  AÑADIR UNA DEPENDENCIA
</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-select
      (selectionChange)="changeFabrica($event.value)"
      placeholder="Seleccionar dispositivo raíz..."
    >
      <mat-option *ngFor="let f of data.fabricas; let i = index" [value]="f">{{
        f.nombre
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <button class="cancelar" mat-button [mat-dialog-close]="null">
    CANCELAR
  </button>
</div>
<div *ngIf="hayFabrica">
  <div *ngFor="let n of nivel; let i = index">
    <button mat-button color="primary" (click)="cambioNivel(n)">
      {{ ".".repeat(i) }}{{ " " }} {{ n.nombre }}
    </button>
  </div>
  <table *ngIf="dsps.length == 0">
    <td style="width: 1%">
      <button mat-button color="primary" [mat-dialog-close]>
        <mat-icon>done</mat-icon>
      </button>
    </td>
  </table>
  <table *ngIf="dsps.length > 0">
    <tbody *ngFor="let d of dsps; let i = index">
      <tr *ngIf="!haydatos[i]">
        <td style="width: 1%">
          <button mat-button color="primary" [mat-dialog-close]="d">
            <mat-icon>done</mat-icon>
          </button>
        </td>
        <td style="width: 1%">
          <button mat-button color="primary" (click)="dispositivoClick(d)">
            <mat-icon>add</mat-icon>
          </button>
        </td>
        <td style="width: 1%">
          <button mat-button color="primary" (click)="datosClick(d)">
            <mat-icon>list_alt</mat-icon>
          </button>
        </td>
        <td style="text-align: left">{{ d.nombre }}</td>
      </tr>
      <tr *ngIf="haydatos(d.uuid)">
        <td></td>
        <td colspan="3">
          <table>
            <!--{{d.uuid}} {{' -> '}}{{d.nombre}}-->
            <tbody *ngFor="let dd of datos; let i = index">
              <td style="width: 1%">
                <button mat-button color="primary" [mat-dialog-close]="dd">
                  <mat-icon>done</mat-icon>
                </button>
              </td>
              <td style="text-align: left">
                {{ dd.periodo }} {{ " - " }} {{ tipoDatos[i].nombre }}
                {{ " - " }} {{ tipoDatos[i].unidad }} {{ " - " }}
                {{ dd.descripcion }}
              </td>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>
